const quizData = [
  {
    category: "Science",
    question: "What is the chemical symbol for water?",
    options: ["Carbon Dioxide Gas", "Molecular Oxygen Gas", "Dihydrogen Monoxide H2O", "Hydroxide Ion Solution"],
    answer: "Dihydrogen Monoxide H2O",
  },
  {
    category: "History",
    question: "Who was the first President of the United States?",
    options: ["Abraham Lincoln Leader", "George Washington President", "John Adams Politician", "Thomas Jefferson Author"],
    answer: "George Washington President",
  },
  {
    category: "General Knowledge",
    question: "Which planet is known as the Red Planet?",
    options: ["Venus Hot Atmosphere", "Jupiter Gas Giant", "Mars Dusty Red Surface", "Saturn Ringed Planet"],
    answer: "Mars Dusty Red Surface",
  },
  {
    category: "Science",
    question: "What is the hardest natural substance on Earth?",
    options: ["Gold Metallic Element", "Diamond Crystal Structure", "Iron Strong Metal", "Quartz Silica Mineral"],
    answer: "Diamond Crystal Structure",
  },
  {
    category: "History",
    question: "In which year did World War II end?",
    options: ["1939 War Begins", "1945 War Ends", "1918 Peace Treaty", "1950 Korean War"],
    answer: "1945 War Ends",
  },
  {
    category: "General Knowledge",
    question: "Which ocean is the largest?",
    options: ["Indian Ocean Waters", "Atlantic Ocean Depths", "Pacific Ocean Surface", "Arctic Ocean Ice"],
    answer: "Pacific Ocean Surface",
  },
  {
    category: "Science",
    question: "Which organ in the human body produces insulin?",
    options: ["Liver Detoxification System", "Pancreas Hormone Secretion", "Kidney Blood Filtration", "Heart Blood Circulation"],
    answer: "Pancreas Hormone Secretion",
  },
  {
    category: "History",
    question: "The Great Wall of China was primarily built to protect against which group?",
    options: ["Roman Empire Soldiers", "Persian Empire Warriors", "Mongol Nomadic Invaders", "Viking Norse Raiders"],
    answer: "Mongol Nomadic Invaders",
  },
  {
    category: "General Knowledge",
    question: "What gas do plants absorb from the atmosphere?",
    options: ["Oxygen Essential Gas", "Carbon Dioxide Absorption", "Nitrogen Fertile Element", "Hydrogen Lightest Gas"],
    answer: "Carbon Dioxide Absorption",
  },
  {
    category: "Science",
    question: "Which element has the atomic number 1?",
    options: ["Helium Noble Gas", "Hydrogen Lightest Element", "Oxygen Life Supporting", "Carbon Organic Compound"],
    answer: "Hydrogen Lightest Element",
  },
  {
    category: "History",
    question: "Which year did the Titanic sink?",
    options: ["1905 Ocean Disaster", "1912 Iceberg Collision", "1898 Tragic Voyage", "1920 Maritime Wreck"],
    answer: "1912 Iceberg Collision",
  },
];

export default quizData;
